import React, { useMemo } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import injectStyles from 'react-jss'
import { Grid } from '@material-ui/core'

import { urlGet } from 'Utils/URL'
import { PATHS } from 'Config/Routing/paths'
import { authorization } from 'Module/Auth/Auth'
import CampaignCard from 'Components/Campaigns/CampaignCard'
import { SectionTitle } from 'Components/Section/SectionTitle/index'
import { SectionWrapper } from 'Components/Section/SectionWrapper/index'
import FilterAndPaginationComponent from 'Components/FilterAndPaginationComponent'
import DataFetchingComponent from 'Components/DataFetchingComponent'
import { fetchCampaignsData } from 'Containers/Campaigns/gql.js'
import {
  CAMPAIGN_ENUM_TYPES,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  STATUS_CAMPAIGN_ENUM_DRAFT,
  STATUS_FILTER_OPTIONS,
} from '../../../../shared/constants'
import { styles } from './styles'
import { SOURCE_OPTIONS } from '../../../../constants'

const CampaignsBlock = ({ classes }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const isClient = authorization.isClient()
  const clientId = match.params.id

  const filters = useMemo(() => {
    return [
      {
        label: 'Status',
        options: STATUS_FILTER_OPTIONS,
        selectedValue: urlGet('Status'),
      },
      {
        label: 'Source',
        options: SOURCE_OPTIONS,
        selectedValue: urlGet('Source'),
      },
      {
        label: 'Channel',
        options: [
          {
            label: 'Hand to hand',
            value: CAMPAIGN_ENUM_TYPES.HANDTOHAND,
          },
          {
            label: 'Letterbox',
            value: CAMPAIGN_ENUM_TYPES.LETTERBOX,
          },
          {
            label: 'Direct Mail',
            value: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
          },
          {
            label: 'Inserts',
            value: CAMPAIGN_ENUM_TYPES.INSERTS,
          },
        ],
        selectedValue: urlGet('Channel'),
      },
    ]
  }, [])

  const fetchData = async args => {
    const { first, skip, Status, Channel, Source } = args

    const shouldFetchActiveDates = [
      STATUS_CAMPAIGN_ENUM_ARCHIVE,
      STATUS_CAMPAIGN_ENUM_ACTIVE,
      STATUS_CAMPAIGN_ENUM_DRAFT,
      undefined,
    ].includes(Status)

    const variables = {
      first,
      skip,
      statuses: Status ? [Status] : undefined,
      types: Channel ? [Channel] : undefined,
      clientIds: [clientId],
      isSelfServe: Source,
    }

    return await fetchCampaignsData({
      isClient,
      shouldFetchActiveDates,
      variables,
    })
  }

  const getCampaignPath = campaign => {
    const baseUrl = `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}/${
      campaign.id
    }`

    if (
      (campaign.type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL &&
        campaign.isSelfServe) ||
      campaign.type === CAMPAIGN_ENUM_TYPES.INSERTS
    ) {
      return `${baseUrl}/dashboard`
    }

    return `${baseUrl}/city-plans`
  }

  return (
    <SectionWrapper className="section-wrapper second">
      <SectionTitle className="section-title">Campaigns</SectionTitle>
      <DataFetchingComponent
        filters={filters}
        fetchData={fetchData}
        showSearch={false}
        match={match}
        Component={props => (
          <FilterAndPaginationComponent
            {...props}
            isComponentTable={false}
            Component={innerProps => {
              return (
                <Grid container spacing={3}>
                  {innerProps.data.length ? (
                    innerProps.data.map(campaign => (
                      <Grid item xs={12} md={6} lg={3} key={'' + campaign.id}>
                        <CampaignCard
                          className="campaign-card"
                          title={campaign.name}
                          subTitle={campaign.client}
                          footer={campaign.type}
                          description={
                            <div>
                              Number of cities{' '}
                              <span className="number">
                                {campaign.cityCount}
                              </span>
                            </div>
                          }
                          img={campaign.clientLogo}
                          status={campaign.status}
                          campaignTimeRange={campaign.campaignTimeRange}
                          onClick={() => {
                            history.push(getCampaignPath(campaign))
                          }}
                          viewPath={getCampaignPath(campaign)}
                          editPath={
                            isClient
                              ? ''
                              : `${PATHS.main.dashboard}${
                                  PATHS.dashboard.campaigns
                                }/${campaign.id}/edit`
                          }
                          updatedAt={campaign.updatedAt}
                          isSelfServe={campaign.isSelfServe}
                        />
                      </Grid>
                    ))
                  ) : (
                    <div className={classes.textCenter}>No campaign found</div>
                  )}
                </Grid>
              )
            }}
          />
        )}
      />
    </SectionWrapper>
  )
}

export default injectStyles(styles)(CampaignsBlock)
